module.exports = __webpack_public_path__ + "img/03_Button-3.7f6e3cc8.png";